import HelloIsland from "../features/hello_island/HelloIsland";
import AiCoach from "../features/ai_coach/AiCoach";
import AiDebrief from "../features/ai_debrief/AiDebrief";
import PerformanceCharts from "../features/performance_charts/PerformanceCharts";
import CourseModuleSubjects from "../features/course_module_subjects/CourseModuleSubjects";
import ManageDevices from "../features/manage_devices/ManageDevices";
import SamplePreview from "../features/sample_preview/SamplePreview";
import ModulePracticeBuilder from "../features/module_practice_builder/ModulePracticeBuilder";
import OutreachComposer from "../features/student_care/OutreachComposer";
import DiagnosticFunnel from "../features/diagnostic_funnel/DiagnosticFunnel";
import MockPerformanceReport from "../features/mock_performance_report/MockPerformanceReport";

export const islands = { HelloIsland, AiCoach, AiDebrief, PerformanceCharts, CourseModuleSubjects, ManageDevices, SamplePreview, ModulePracticeBuilder, OutreachComposer, DiagnosticFunnel, MockPerformanceReport };
